module.exports = "<div class=\"d-flex flex-column\"><div class=subtitle>Social</div><div ng-form=$ctrl.socialForm><div class=gmc-form-group ng-repeat=\"field in ::$ctrl.formFields\"><label class=gmc-form-label>{{::field.label}} <input class=gmc-form-control name={{::field.name}} ng-model=$ctrl.socials[field.name] placeholder={{::field.placeholder}}></label></div><div class=btn-save ng-if=::$ctrl.showSave><button type=button ng-click=$ctrl.submit() class=\"btn btn-green\">Save</button></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/social-form/social-form.component.html
// module id = 845
// module chunks = 31